
import React from 'react';
import { Customer } from '../components/customer-selector/types';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ShoppingBag, Package, PackageMinus, Coins } from 'lucide-react';

interface OrderFormCustomerStatsProps {
  selectedCustomer?: Customer | null;
}

const OrderFormCustomerStats = ({ selectedCustomer }: OrderFormCustomerStatsProps) => {
  if (!selectedCustomer) return null;

  const hasStats = selectedCustomer.stats || 
                  (selectedCustomer.orders_count !== undefined && selectedCustomer.orders_count >= 0);

  return (
    <div className="space-y-4">
      {/* Customer Stats */}
      {hasStats && (
        <Card className="border-purple-100">
          <CardHeader className="pb-2 bg-purple-50 border-b border-purple-100">
            <CardTitle className="text-sm flex items-center gap-2 text-purple-700">
              <ShoppingBag className="h-4 w-4 text-purple-500" />
              Statistiques client
            </CardTitle>
          </CardHeader>
          <CardContent className="p-4">
            <div className="grid grid-cols-3 gap-4 text-sm">
              <div className="bg-purple-50 p-3 rounded-md flex flex-col items-center">
                <ShoppingBag className="h-5 w-5 text-purple-500 mb-1" />
                <span className="text-xs text-gray-600">Commandes</span>
                <span className="font-semibold text-lg text-purple-700">
                  {selectedCustomer.stats?.orders_count || selectedCustomer.orders_count || 0}
                </span>
              </div>
              
              <div className="bg-green-50 p-3 rounded-md flex flex-col items-center">
                <Package className="h-5 w-5 text-green-500 mb-1" />
                <span className="text-xs text-gray-600">Livrées</span>
                <span className="font-semibold text-lg text-green-700">
                  {selectedCustomer.stats?.delivered_products || 0}
                </span>
              </div>
              
              <div className="bg-red-50 p-3 rounded-md flex flex-col items-center">
                <PackageMinus className="h-5 w-5 text-red-500 mb-1" />
                <span className="text-xs text-gray-600">Retournées</span>
                <span className="font-semibold text-lg text-red-700">
                  {selectedCustomer.stats?.returned_products || 0}
                </span>
              </div>
            </div>
            
            {selectedCustomer.stats?.total_spent !== undefined && (
              <div className="mt-3 pt-3 border-t border-gray-100">
                <p className="text-sm flex justify-between">
                  <span className="font-medium text-gray-700">Total dépensé:</span>
                  <span className="font-semibold text-purple-700">
                    {new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'DZD' })
                      .format(selectedCustomer.stats.total_spent)
                      .replace('DZD', 'DA')}
                  </span>
                </p>
              </div>
            )}
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default OrderFormCustomerStats;
